import { useMemo } from 'react';
import { useBusinessMeta, useOperationsData } from '../../../contexts/dataContextSlices';

/**
 * Expired products + cash discrepancy / écart management (Strangler over DataContext).
 */
export function useOperationsDomain() {
  const meta = useBusinessMeta();
  const operations = useOperationsData();

  return useMemo(
    () => ({
      ...operations,
      currentBusinessId: meta.currentBusinessId,
      ready: meta.ready,
      dataLoaded: meta.dataLoaded
    }),
    [meta, operations]
  );
}
